export const APP_CONFIG = {
  // Okta issuer
  // Example:
  // https://trial-4436563.okta.com/oauth2/default

  issuer: "https://integrator-7560573.okta.com/",

  // OIDC application Client ID created in Okta
  clientId: "0oa18o2uyupVFzJvD698",

  redirectUri: `${window.location.origin}/login/callback`,

  postLogoutRedirectUri: `${window.location.origin}/`,

  scopes: [
    "openid",
    "profile",
    "email"
  ],

  sharePointUrl:
    "https://kapilkhannapersonalgmail.sharepoint.com/sites/DefaultDirectory/",

  groupCheckApi:
    window.APP_DEPLOYMENT_CONFIG?.groupCheckApi ||
    (window.location.hostname === "localhost"
      ? "http://localhost:3001/api/check-okta-group"
      : "/api/check-okta-group")
};
